import {
  Component,
  EventEmitter,
  Input,
  Output,
  booleanAttribute,
} from '@angular/core';

@Component({
  selector: 'sigecom-modal',
  template: `
    <div
      class="bg-sigecom-modal-dark fixed inset-0 w-full h-full z-[120] flex justify-center items-center"
      *ngIf="open"
      (click)="clickOutside ? toggleModal() : null"
    >
      <div
        class="w-auto min-w-[5rem] min-h-[5rem] bg-white relative max-h-[80%] max-w-6xl flex flex-col overflow-hidden rounded-xl animate-open-modal"
        [ngClass]="{
          'bg-[radial-gradient(circle_at_center,_#0241CF_0%,_#031846_100%)] border-l-white boder shadow-flat-4xl shadow-white/30': alternativeStyle,
        }"
        (click)="$event.stopPropagation()"
      >
        <div
          *ngIf="metadata"
          class="w-full absolute top-0 py-4 z-10 bg-[#e5e7eb] flex justify-between items-center px-5"
        >
          <p class="ml-1 text-sigecom-info"
          >{{ metadata }}</p>
          <fa-icon
            icon="xmark"
            (click)="toggleModal()"
            class="text-xl text-sigecom-gray mr-2 cursor-pointer"
            *ngIf="showCloseButton"
          ></fa-icon>
        </div>
        <div
          *ngIf="!metadata && showCloseButton"
          class="p-2 absolute right-4 top-4 z-40 text-xl cursor-pointer"
        >
          <fa-icon
          icon="xmark"
          (click)="toggleModal()"
          ></fa-icon>
        </div>
        <div
          [ngClass]="{ 'mt-12': metadata }"
          class="overflow-x-hidden overflow-y-auto flex-1 p-5 mt-0"
        >
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
})
export class ModalComponent {
  @Input() metadata?: string;
  @Input() open: boolean = false;
  @Input({ transform: booleanAttribute }) clickOutside: boolean = false;
  @Output() modalStateChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Input() showCloseButton: boolean = true;
  @Input() closeButtonClass: string = 'text-black'; // cor padrão
  @Input() alternativeStyle: boolean = false;


  constructor() {}

  toggleModal() {
    this.open = !this.open;
    this.modalStateChange.emit(this.open);
  }

  closeModal() {
    this.open = false;
    this.modalStateChange.emit(this.open);
  }
}
